/**
 * Root reducer with support for lazy slice injection.
 *
 * Static reducers (auth, api) are always present. Feature slices can register
 * themselves at load time via `injectReducer(key, reducer)` so their state code
 * splits with the feature bundle instead of loading upfront. `store.js` wires
 * `combine()` to the store's replaceReducer.
 */
import { combineReducers } from '@reduxjs/toolkit';

import { baseApi } from '@services/baseApi';
import authReducer from '@security/auth/authSlice';

const staticReducers = {
  auth: authReducer,
  [baseApi.reducerPath]: baseApi.reducer,
};

const asyncReducers = {};

export function combine() {
  return combineReducers({ ...staticReducers, ...asyncReducers });
}

/**
 * Register a lazily-loaded reducer. Call once from a feature's index.
 * @returns {boolean} true if a new reducer was added (store must rebuild)
 */
export function registerReducer(key, reducer) {
  if (asyncReducers[key] || staticReducers[key]) return false;
  asyncReducers[key] = reducer;
  return true;
}
